import { markRaw, type Component } from 'vue'
import AiToolsPicture from './AiToolsPicture.vue'
import AiToolsMentorPicture from './AiToolsMentorPicture.vue'
import InstantRequestPicture from './InstantRequestPicture.vue'
import MemoryBriefPicture from './MemoryBriefPicture.vue'
import QuestionPagesPicture from './QuestionPagesPicture.vue'

// The button opens `href`, or starts the feature tour named in `tour`
// (modules/feature-tour). `secondary` adds a second button that only closes
// the window.
export type FeatureAnnouncement = {
  title: string
  line: string
  button: string
  href?: string
  tour?: string
  secondary?: string
  picture: Component
}

// One entry per key of FeatureInteractions::FeatureAnnouncementGate. The next
// launch adds its key here: the window itself does not change.
export const ANNOUNCEMENTS: Record<string, FeatureAnnouncement> = {
  instant_sessions_intro: {
    title: 'Meet the other mentors.',
    line: 'Go live and talk to a mentor for 15 minutes. No booking.',
    button: 'Open Live now',
    href: '/live',
    picture: markRaw(InstantRequestPicture),
  },
  // With the flag live-now-tour this window takes the place of
  // instant_sessions_intro, also for a mentor who saw that one.
  live_now_tour_intro: {
    title: 'Meet the other mentors.',
    line: 'Go live and talk to a mentor for 15 minutes. No booking. The tour shows you how it works.',
    button: 'Take the tour',
    tour: 'live_now',
    secondary: 'Not now',
    picture: markRaw(InstantRequestPicture),
  },
  question_pages_intro: {
    title: 'Founders asked. You answered.',
    line: 'We found the questions founders ask most on calls, and what you told them. Each question is a page. Nothing of yours is public until you say yes.',
    button: 'Take the tour',
    tour: 'question_pages',
    secondary: 'Not now',
    picture: markRaw(QuestionPagesPicture),
  },
  member_memory_intro: {
    title: 'Your mentors now know your business.',
    line: 'We wrote a brief about your business from your calls. Your next mentor reads it before the call, so you do not explain it again. You can turn any part off. The tour shows you how.',
    button: 'Take the tour',
    tour: 'memory',
    secondary: 'Not now',
    picture: markRaw(MemoryBriefPicture),
  },
  ai_tools_intro: {
    title: 'Your AI tool can book your mentors.',
    line: 'Connect Claude Code, Codex or Cursor once. Then ask it to find a mentor, book a call or read your call notes. The tour shows you how.',
    button: 'Take the tour',
    tour: 'ai_tools',
    secondary: 'Not now',
    picture: markRaw(AiToolsPicture),
  },
  ai_tools_mentor_intro: {
    title: 'Your AI tool can read the calls you gave.',
    line: 'Connect Claude Code, Codex or Cursor once. Then ask it to prep your next call, draft a post from your calls or find help requests to answer. The tour shows you how.',
    button: 'Take the tour',
    tour: 'ai_tools_mentor',
    secondary: 'Not now',
    picture: markRaw(AiToolsMentorPicture),
  },
}
